import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';
import StandardNavbar from '../components/StandardNavbar';

function Destinos() {
  const [destinos, setDestinos] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get('http://localhost:5000/api/destinos')
      .then(res => {
        if (res.data.estado === 1) {
          setDestinos(res.data.destinos);
        } else {
          setError(res.data.description);
        }
      })
      .catch(err => setError('Error al cargar destinos: ' + err.message));
  }, []);

  return (
    <>
      <Helmet>
        <title>Destinos | Noche y Día Turismo</title>
        <meta name="description" content="Descubre nuestros destinos de viaje." />
      </Helmet>
      <StandardNavbar />
      <div className="container mx-auto p-4">
        <h1 className="text-3xl font-bold text-custom-purple">Destinos</h1>
        {error && <p className="text-red-500">{error}</p>}
        <ul className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
          {destinos.map(dest => (
            <li key={dest.id} className="bg-white p-4 rounded shadow">
              <h2 className="text-xl">{dest.nombre}</h2>
              <p>Creado: {dest.create}</p>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}

export default Destinos;